import React from 'react';

export const Title = ({ greeting }) => {
    return (
        <h1>{greeting}</h1>
    );
}

export default Title;